import { render, staticRenderFns } from "./NewSurvey.vue?vue&type=template&id=37f26173&scoped=true"
import script from "./NewSurvey.vue?vue&type=script&lang=js"
export * from "./NewSurvey.vue?vue&type=script&lang=js"
import style0 from "./NewSurvey.vue?vue&type=style&index=0&id=37f26173&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f26173",
  null
  
)

export default component.exports